import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69ac407f886e1000141e44bb/videoportfolio/src/app/homepage/page.tsx");
